const fontList = [
    {
        value: 'Arial',
        label: 'Arial',
    },
    {
        value: 'Helvetica',
        label: 'Helvetica',
    },
    {
        value: 'Times New Roman',
        label: 'Times New Roman',
    },
    {
        value: 'Courier New',
        label: 'Courier New',
    },
    {
        value: 'Verdana',
        label: 'Verdana',
    },
    {
        value: 'Georgia',
        label: 'Georgia',
    },
    {
        value: 'Palatino',
        label: 'Palatino',
    },
    {
        value: 'Tahoma',
        label: 'Tahoma',
    },
    {
        value: 'Futura',
        label: 'Futura',
    },
    {
        value: 'Calibiri',
        label: 'Calibiri',
    },
];

const fontSizes = [
    '8',
    '9',
    '10',
    '11',
    '12',
    '14',
    '18',
    '24',
    '30',
    '36',
    '48',
    '60',
    '72',
    '96',
];

export { fontList, fontSizes };
